<kodit-info-container>
  <!-- Tabela -->
  <kodit-kpo-knjiga-table body-2-of-3></kodit-kpo-knjiga-table>

  <!-- PDF -->
  <kodit-kpo-knjiga-pdf body-1-of-3></kodit-kpo-knjiga-pdf>
</kodit-info-container>
